var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("nav-bar", {
        attrs: { pageName: _vm.pageName, sidebarIsOpen: _vm.sidebarIsOpen },
        on: { "toggle-nav": _vm.toggleSidebar }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c("side-bar", {
            attrs: { menu: _vm.menu, sidebarIsOpen: _vm.sidebarIsOpen },
            on: { "toggle-sidebar": _vm.toggleSidebar }
          }),
          _vm._v(" "),
          _c(
            "main-content",
            { attrs: { sidebarIsOpen: _vm.sidebarIsOpen } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-360fa22f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360fa22f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Management.vue
// module id = null
// module chunks = 